import React from "react";
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
import {getRemittanceExcelDetails} from "../network/RemittanceExcelDownloadAPI";
import Button from "@amzn/meridian/button";
import {getReadableLabel, parseVarianceReason} from "../../common/commonUtils"
import { ExcelVarianceReasonFormat, VarianceType } from "../../common/remittanceV2Constants";
import { publishCount } from "../../../MetricUtility";
import { Metric, PROCESS_NAME} from "../../common/constants";

class RemittanceExcelDownload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataForExcel : {
                remittanceAmount :0.0,
                aggregatedShortExcessCash:0.0,
                coinsDiff:0.0,
                counterfeitNotesDiff:0.0,
                otherCashDiff:0.0,
                issueLink:"",
                slpCashRecovery:0.0,
                issueLinkForSLPRecovery:"",
                netCashDiff:0.0,
                actualAmount:0.0,
                associateReconciliationDetails:[
                    {
                        associateId:"",
                        associateName:"",
                        timestamp:0,
                        cashDifference:0.0,
                        cashDifferenceReason:"",
                        ttLink:""
                    }
                ],
                shipmentInformationList:[
                    {
                        depositCode:"",
                        trackingId:"",
                        amount:0.0,
                        statusUpdateTimeStamp:0,
                        associateName:"",
                        station:""
                    }
                ],
                stationVariance: []
            }
        };
        this.export = this.export.bind(this);
        this.fetchDataForExcel = this.fetchDataForExcel.bind(this);
    }

    getStationVarianceDetails = () => {
        const details = {};
        const stationVariance = this.state.dataForExcel.stationVarianceList;
        if (stationVariance) {
            stationVariance.forEach(variance => {
                const reason = getReadableLabel(parseVarianceReason(variance.reason, ExcelVarianceReasonFormat.REASON_CODE));
                const issueLink = parseVarianceReason(variance.reason, ExcelVarianceReasonFormat.ISSUE_LINK);
                details[reason] = variance.type === VarianceType.SHORT ? -variance.amount.value : variance.amount.value ;
                if (issueLink) {
                    details[reason + " link"] = issueLink;
                }
            })
        }
        return details;
    }

    fetchDataForExcel = () => {
        const remittanceId = this.props.RemittanceId;
        return getRemittanceExcelDetails({
            remittanceId
        }).then(response => {
            if (response.status === 200) {
                const {data: {remittanceDetails}} = response;
                this.setState({dataForExcel : remittanceDetails});
                publishCount(PROCESS_NAME, Metric.GetRemittanceDetailsForExcel);
            } else {
                this.setState({ errorMessage: "Failed to fetch details required for excel"});
                publishCount(PROCESS_NAME, Metric.GetRemittanceDetailsForExcel_Failure);
                publishCount(PROCESS_NAME, Metric.GetRemittanceDetailsForExcel);
            }
        }).then(
            () => this.export()
        ).catch(err => {
            this.setState({ errorMessage: "Failed to fetch details required for excel"});
            publishCount(PROCESS_NAME, Metric.GetRemittanceDetailsForExcel_Failure);
            publishCount(PROCESS_NAME, Metric.GetRemittanceDetailsForExcel);
        });
    }
    export = () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const{ dataForExcel } = this.state;
        console.log(dataForExcel)
        const remittanceSubmissionList = [];
        if (this.props.submitRemittanceV2Flag) {
            remittanceSubmissionList.push(
                {
                    actualAmount:dataForExcel.actualAmount,
                    aggregatedShortExcessCash:dataForExcel.aggregatedShortExcessCash,
                    ...this.getStationVarianceDetails(),
                    netCashDiff:dataForExcel.netCashDiff,
                    remittanceAmount:dataForExcel.remittanceAmount,
                }
            )
        } else {
            remittanceSubmissionList.push(
                {
                    actualAmount:dataForExcel.actualAmount,
                    aggregatedShortExcessCash:dataForExcel.aggregatedShortExcessCash,
                    coinsDiff:dataForExcel.coinsDiff,
                    counterfeitNotesDiff:dataForExcel.counterfeitNotesDiff,
                    issueLink: dataForExcel.issueLink,
                    issueLinkForSLPRecovery:dataForExcel.issueLinkForSLPRecovery,
                    netCashDiff:dataForExcel.netCashDiff,
                    otherCashDiff:dataForExcel.otherCashDiff,
                    remittanceAmount:dataForExcel.remittanceAmount,
                    slpCashRecovery:dataForExcel.slpCashRecovery
                }
            )
        }
        let shipmentInfoList = []
        if (dataForExcel.shipmentInformationList.length === 0) {
            shipmentInfoList.push({
                depositCode: null,
                trackingId: null,
                amount: null,
                statusUpdateTimeStamp: null,
                associateName: null,
                station: null
            });
        } else {
            shipmentInfoList = dataForExcel.shipmentInformationList;
        }
        let associateReconciliationDetailsList = []
        if (dataForExcel.associateReconciliationDetails.length === 0) {
            associateReconciliationDetailsList.push({
                associateId: null,
                associateName: null,
                timestamp: null,
                cashDifference: null,
                cashDifferenceReason: null,
                ttLink: null
            });
        } else {
            associateReconciliationDetailsList = dataForExcel.associateReconciliationDetails;
        }
        const remittanceSubmissionSheet = remittanceSubmissionList;
        const associateReconciliationDetailsSheet = associateReconciliationDetailsList;
        const shipmentInfoSheet = shipmentInfoList;
        //Prepare xlsx output
        var today = new Date();
        var date = '-'+(today.getMonth()+1)+'-'+today.getDate()+'_'+today.getHours() + "_" + today.getMinutes();
        const fileName = "RemittanceShipmentsDownload"+date;
        const remittanceSubmissionSheetName = "Short or Excess Cash Submitted";
        const associateReconciliationDetailsSheetName = "Short or Excess Cash DA Breakup";
        const shipmentInfoSheetName = "Shipment Information";
        const workBook = {SheetNames: [], Sheets: {}};
        const remittanceSubmissionWorkSheet = XLSX.utils.json_to_sheet(remittanceSubmissionSheet);
        const associateReconciliationDetailsWorkSheet = XLSX.utils.json_to_sheet(associateReconciliationDetailsSheet);
        const shipmentInfoWorkSheet = XLSX.utils.json_to_sheet(shipmentInfoSheet);
        workBook.SheetNames.push(remittanceSubmissionSheetName);
        workBook.SheetNames.push(associateReconciliationDetailsSheetName);
        workBook.SheetNames.push(shipmentInfoSheetName);
        workBook.Sheets[remittanceSubmissionSheetName] = remittanceSubmissionWorkSheet;
        workBook.Sheets[associateReconciliationDetailsSheetName] = associateReconciliationDetailsWorkSheet;
        workBook.Sheets[shipmentInfoSheetName] = shipmentInfoWorkSheet;
        const excelBuffer = XLSX.write(workBook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});

        /* the saveAs call downloads a file on the local machine */
        FileSaver.saveAs(data, fileName + fileExtension);
    }
    render() {
        return (
            <div>
                <div><Button size="small" onClick={this.fetchDataForExcel}>Download</Button></div>
            </div>
        );
    }
}

export default RemittanceExcelDownload;


// WEBPACK FOOTER //
// ./src/component/remittance/list/RemittanceExcelDownload.js